var _circle, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.17932,
    cy: 6.17932,
    r: 5.74999,
    fill: "url(#paint0_linear_1182_4640)",
    stroke: "#4F56DD",
    strokeWidth: 0.858665
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67904 9.47656H7.04297V7.8405L8.67904 9.47656Z",
    fill: "#3F45B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85368 9.47656H5.48975V7.8405L3.85368 9.47656Z",
    fill: "#3F45B7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1182_4640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.23507 2.77669L9.44672 4.78729L7.74299 4.44866L7.2668 9.18945H5.20329L4.72709 4.44866L3.01279 4.78729L3.22443 2.77669H9.23507Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1182_4640",
    x: 0.896271,
    y: 2.77686,
    width: 10.6669,
    height: 10.6454,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.11642
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.05821
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1182_4640"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1182_4640",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1182_4640",
    x1: 6.17932,
    y1: 0,
    x2: 6.17932,
    y2: 12.3586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F56DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F56DD",
    stopOpacity: 0.83
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/money_icon.732b1311ffee46e21537b79d66499e27.svg";
export { ForwardRef as ReactComponent };